import React from "react";

const IntegrationsSection = ({ t, language }) => (
  <section className="integrations anim-section home-section" id="integraciones">
    <div className="home-container">
      <div className="section-head integrations-head">
        <h2>{language === "es" ? "White Label Ready · Device-Agnostic" : "White Label Ready · Device-Agnostic"}</h2>
        <p>
          {language === "es"
            ? "Para integradores: acelera tu go-to-market con una infraestructura lista para rebranding e integración. Para operadores y exportadores: adopta seguridad avanzada sin amarrarte a un único fabricante."
            : "For integrators: accelerate your go-to-market with infrastructure ready for rebranding and integration. For operators and exporters: adopt advanced security without being tied to a single manufacturer."}
        </p>
      </div>

      <div className="integrations-columns">
        <div className="integration-panel card-animated anim-card">
          <h3>{language === "es" ? "Para integradores" : "For integrators"}</h3>
          <ul>
            <li>
              {language === "es"
                ? "Marca blanca (rebranding) y multi-tenant (si lo necesitas)."
                : "White label (rebranding) and multi-tenant (if you need it)."}
            </li>
            <li>
              {language === "es"
                ? "APIs abiertas y conectores para integraciones rápidas."
                : "Open APIs and connectors for fast integrations."}
            </li>
            <li>
              {language === "es"
                ? "Device-agnostic: integra GPS, sellos electrónicos, cámaras y más."
                : "Device-agnostic: integrate GPS, e-seals, cameras, and more."}
            </li>
            <li>
              {language === "es"
                ? "Modelo comercial flexible: licenciamiento / revenue share / proyectos."
                : "Flexible commercial model: licensing / revenue share / projects."}
            </li>
          </ul>
        </div>

        <div className="integration-panel card-animated anim-card">
          <h3>{language === "es" ? "Para operaciones críticas" : "For critical operations"}</h3>
          <div className="integration-highlight">
            <h4>{language === "es" ? "Visibilidad por excepción" : "Exception-based visibility"}</h4>
            <p>
              {language === "es"
                ? "Prioriza lo importante: desviaciones, paradas no autorizadas, eventos críticos y señales de manipulación."
                : "Focus on what matters: deviations, unauthorized stops, critical events, and tamper signals."}
            </p>
          </div>
          <ul>
            <li>
              {language === "es"
                ? "Alertas automatizadas para respuesta rápida."
                : "Automated alerts for rapid response."}
            </li>
            <li>
              {language === "es"
                ? "Auditoría visual y evidencia por checkpoint."
                : "Visual auditing and checkpoint evidence."}
            </li>
            <li>
              {language === "es"
                ? "Reportes programados y BI (operativo e histórico)."
                : "Scheduled reports and BI (operational and historical)."}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
);

export default IntegrationsSection;
